// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/**
 * Dark-launch kill switch for the subscription UI. Unset (the default in every environment today)
 * means disabled. This only hides the entry point — the backend refuses checkout/portal requests
 * independently via Payments:SubscriptionsEnabled, so this flag is not itself a security boundary.
 *
 * Must stay a plain `process.env.EXPO_PUBLIC_X` member expression: babel-preset-expo only inlines
 * that exact form into native bundles, so optional-chaining or destructuring this would silently
 * read as undefined on device while still working on web.
 */
export function isSubscriptionsFeatureEnabled(): boolean {
  return process.env.EXPO_PUBLIC_SUBSCRIPTIONS_ENABLED === 'true';
}
